<form
    [formGroup]="form"
    *yssIsLoading="subFormIsLoading$ | async">
    <div class="row">
        <app-user-select-or-create
            [form]="form"
            [selectedUser]="action.customer"></app-user-select-or-create>
        <div class="col-6 subject-select-holder">
            <label class="padded-top-gray-label"> Products (Optional) </label>
            <div class="products-select-holder">
                <ng-select
                    formControlName="products"
                    [clearable]="false"
                    [searchable]="true"
                    [closeOnSelect]="false"
                    [placeholder]="'Select products'"
                    [multiple]="true"
                    class="products-selector">
                    <ng-option
                        [value]="product.id"
                        *ngFor="let product of allProducts">
                        {{ product.name }}
                    </ng-option>
                </ng-select>
                <div class="product-chips">
                    <div
                        *ngFor="let selectedProduct of selectedProducts"
                        class="product-chip">
                        {{ selectedProduct.name }}
                        <div
                            class="product-chip-close-icon"
                            (click)="removeProduct(selectedProduct)">
                            <img src="/assets/images/chat/chip-remove-icon.svg" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6">
            <label class="padded-top-gray-label">Query:</label>
            <input
                type="text"
                class="normal-text-input"
                placeholder="Enter query:"
                formControlName="query"
                [ngClass]="{
                    'normal-text-input--invalid':
                        form.controls.query?.invalid && (form.controls.query?.dirty || form.controls.query?.touched)
                }" />
        </div>
        <div class="col-6 subject-select-holder">
            <label class="padded-top-gray-label">Subject for Order Query:</label>
            <input
                type="text"
                class="normal-text-input"
                placeholder="Enter subject"
                formControlName="subject"
                [ngClass]="{
                    'normal-text-input--invalid':
                        form.controls.subject?.invalid &&
                        (form.controls.subject?.dirty || form.controls.subject?.touched)
                }" />
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <input
                type="checkbox"
                class="form-check-input checkbox-dark-styled"
                formControlName="sendNotificationToCustomer" />
            <span class="sent-request-back-msg">
                Notify the customer (action will appear on email and customer dashboard)
            </span>
        </div>
    </div>
</form>
